import React, { useState } from 'react';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import './topLandingNavStyle.scss';

const HoverDropdown = ({ title, items, columns = 1 }) => {
  const [show, setShow] = useState(false);

  // Create columns only if needed
  let chunkedItems = [];
  if (columns > 1) {
    const itemsPerColumn = Math.ceil(items.length / columns);
    for (let i = 0; i < items.length; i += itemsPerColumn) {
      chunkedItems.push(items.slice(i, i + itemsPerColumn));
    }
  }

  return (
    <li
      className={`nav-item nav-li-padding dropdown ${show ? 'show' : ''}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <a
        className="nav-link dropdown-toggle"
        href="#"
        role="button"
        aria-expanded={show ? 'true' : 'false'}
      >
        {title} <KeyboardArrowDownRoundedIcon style={{ fontSize: 18 }} />
      </a>

      {/* Mega Menu (2+ columns) */}
      {columns > 1 ? (
        <div className={`dropdown-menu mega-menu ${show ? 'show' : ''}`}>
          <div className="row g-0">
            {chunkedItems.map((col, i) => (
              <div className="col-md-6 px-3" key={i}>
                <ul className="list-unstyled">
                  {col.map((item, j) => (
                    <li key={j}>
                      <a className="dropdown-item dropdown-height" href={item.link} target={item?.target?item.target:''}>
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ) : (
        // Regular Dropdown (1 column)
        <ul className={`dropdown-menu custom-dropdown ${show ? 'show' : ''}`}>
          {items.map((item, index) => (
            <li key={index}>
              <a className="dropdown-item dropdown-height" href={item.link} target={item?.target?item.target:''}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default HoverDropdown;